<!--<div>-->
<!--  <h3>Sticky Header. Paginator under</h3>-->
<!--  <aur-mat-table class="limit-size"-->
<!--                 [tableData]="tableData"-->
<!--                 [tableConfig]="tableConfigPaginatorUnder">-->
<!--  </aur-mat-table>-->
<!--</div>-->

<div>
  <h3>Sticky Header. Paginator bottom</h3>
  <aur-mat-table class="limit-size"
                 [tableData]="tableData"
                 [tableConfig]="tableConfigPaginatorBottom">
  </aur-mat-table>
</div>
